import React, { useState } from 'react';

import { IconButton, ClickAwayListener, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, TextField } from '@hydra/common/components';

import { sendEvent } from '@hydra/utils/gtm';

const useStyles = makeStyles(theme => ({
  root: { marginRight: theme.spacing(2) },
  active: {
    display: 'flex'
  }
}));

function EndAdornment ({ handleClose }) {
  return (
    <InputAdornment position='end'>
      <IconButton size='small' onClick={handleClose}>
        <Icon type='cross' size='sm' color='secondary' />
      </IconButton>
    </InputAdornment>
  );
}

export default function RankedKeywordsSearch ({ keywordFilter, setKeywordFilter }) {
  const classes = useStyles();
  const [active, setActive] = useState(false);
  const handleChange = event => {
    setKeywordFilter(event.target.value);
  };

  const handleClose = () => {
    setKeywordFilter('');
    setActive(false);
  };

  const handleClickAway = () => {
    if (!keywordFilter) {
      handleClose();
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      handleClose();
    }
  };

  const handleSearchClick = () => {
    sendEvent('keywordtool-addkeyword-rankedkeywordssearch-btn');
    setActive(true);
  };

  return (
    <div className={classes.root}>
      <ClickAwayListener onClickAway={handleClickAway}>
        {active
          ? (
            <div className={classes.active}>
              <IconButton size='medium'>
                <Icon type='search' size='md' />
              </IconButton>
              <TextField
                autoFocus
                margin='none'
                disableShadow
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                value={keywordFilter}
                InputProps={{
                  endAdornment: <EndAdornment handleClose={handleClose} />
                }}
              />
            </div>
            )
          : (
            <IconButton size='medium' onClick={handleSearchClick}>
              <Icon type='search' size='md' />
            </IconButton>
            )}
      </ClickAwayListener>
    </div>
  );
}
